module.exports = __webpack_public_path__ + "img/logonewest.20bdb802.svg";